<template>
    <div id="content">
        <breadcrumbs :page="categoryName" :show-password-field="true" offset-top="0"/>
        <div class="container">
            <albums :items="albums"/>
        </div>
        <powered-by v-if="hasPoweredBy"/>
        <vue-headful :title="headTitle($t('gallery'))"/>
    </div>
</template>

<script>
  import Albums from '../components/Albums.vue';
  import PoweredBy from '../components/PoweredBy.vue';
  import Breadcrumbs from '../components/Breadcrumbs.vue';

  import albums from 'src/mixins/albumsPage';

  export default {
    mixins: [albums],
    components: {
      Albums,
      PoweredBy,
      Breadcrumbs,
    },
  };
</script>
